export const EDIT_CLIENT_KEY = 'edit-client';
export const EDIT_TENANT_KEY = 'edit-tenant';
export const DEACTIVATE_TENANT_KEY = 'deactivate-tenant';
export const DELETE_TENANT_KEY = 'delete-tenant';
export const CLIENTS_COLUMN_KEY = 'clientName';
export const TENANTS_COLUMN_KEY = 'tenantName';
export const ACTIVE_COLUMN_KEY = 'active';
export const TENANT_TYPE_COLUMN_KEY = 'tenantType';
export const DATE_MODIFIED_COLUMN_KEY = 'dateModified';
export const SUBSCRIPTIONS_COLUMN_KEY = 'subscriptions';
export const LEARNING_COLUMN_KEY = 'learning';
export const ASSESSMENT_COLUMN_KEY = 'assessment';
export const DATA_COLUMN_KEY_ATTRIBUTE = 'data-column-key';
